import React, {useCallback, useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import {Center, ContainerSX, SectiuneTitluFontSX, UnderlineTextSX} from "../App.styles";
import {Button, Container, Fade, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import Modal from '@mui/material/Modal';
import {makeStyles} from "@mui/styles";
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import useMediaQuery from '@mui/material/useMediaQuery';

function importAll(r, category) {
    return r.keys().map((item, index) => ({
        src: r(item),
        title: `${category} - ${index}`
    }));
}

const useStyles = makeStyles((theme) => ({
    modalImage: {
        width: '100%',
        height: 'auto',
        maxHeight: '80vh',
        maxWidth: '90vw',
        objectFit: 'contain',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
}));

export default function TitlebarBelowMasonryImageList() {
    const category1Images = importAll(require.context('../imaginiProiecte/Category1', false, /\.(png|jpe?g|svg)$/), 'Category 1');
    const category2Images = importAll(require.context('../imaginiProiecte/Category2', false, /\.(png|jpe?g|svg)$/), 'Category 2');
    const category3Images = importAll(require.context('../imaginiProiecte/Category3', false, /\.(png|jpe?g|svg)$/), 'Category 3');
    const category4Images = importAll(require.context('../imaginiProiecte/Category4', false, /\.(png|jpe?g|svg)$/), 'Category 4');
    const category5Images = importAll(require.context('../imaginiProiecte/Category5', false, /\.(png|jpe?g|svg)$/), 'Category 5');

    const [images, setImages] = useState(category1Images);
    const [selectedCategory, setSelectedCategory] = useState('category1');

    const isXs = useMediaQuery('(max-width:600px)');
    const isSm = useMediaQuery('(min-width:600px) and (max-width:900px)');
    const cols = isXs ? 1 : isSm ? 2 : 3;

    const handleButtonClick = (category) => {
        setSelectedCategory(category);
        switch (category) {
            case 'category1':
                setImages(category1Images);
                break;
            case 'category2':
                setImages(category2Images);
                break;
            case 'category3':
                setImages(category3Images);
                break;
            case 'category4':
                setImages(category4Images);
                break;
            case 'category5':
                setImages(category5Images);
                break;
            default:
                setImages([...category1Images, ...category2Images, ...category3Images, ...category4Images, ...category5Images]);
                break;
        }
    }

    const classes = useStyles();

    const [open, setOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);
    const [originalOverflow, setOriginalOverflow] = useState(null);

    const handleOpen = (index) => {
        setSelectedImageIndex(index);
        setOpen(true);
        setOriginalOverflow(document.body.style.overflow);
        document.body.style.overflow = 'hidden';
    };

    const handleNext = (e) => {
        e.stopPropagation();
        setSelectedImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const handlePrev = (e) => {
        e.stopPropagation();
        setSelectedImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    const handleClose = () => {
        setOpen(false);
        setTimeout(() => {
            document.body.style.overflow = originalOverflow;
        }, 0.0001);
    };

    return (
        <div style={{backgroundColor: '#EEEEEE', minHeight: '100vh'}}>
            <div style={Center}>
                <Container
                    sx={{...ContainerSX, backgroundColor: '#EEEEEE'}}
                    maxWidth={false}
                    padding={0}
                >
                    <Typography component="h2" variant="h3" color="text.primary" style={SectiuneTitluFontSX}>
                        Proiecte
                    </Typography>
                    <Box sx={UnderlineTextSX}/>

                    <Stack spacing={2} direction="row" flexWrap="wrap" useFlexGap justifyContent={isXs ? 'center' : 'flex-start'}>
                        {['category1','category2','category3','category4','category5'].map((cat, i) => (
                            <Button
                                key={cat}
                                variant="contained"
                                size={isXs ? 'small' : 'medium'}
                                onClick={() => handleButtonClick(cat)}
                                sx={{
                                    backgroundColor: selectedCategory === cat ? 'transparent' : '#00ADB5',
                                    color: selectedCategory === cat ? '#00ADB5' : '#EEEEEE',
                                    '&:hover': {
                                        backgroundColor: selectedCategory === cat ? 'transparent' : '#00ADB5',
                                        color: selectedCategory === cat ? '#00ADB5' : '#EEEEEE',
                                    },
                                    flex: isXs ? '1 1 calc(50% - 8px)' : '0 0 auto'
                                }}
                            >
                                {`Category ${i+1}`}
                            </Button>
                        ))}
                    </Stack>

                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                    }}>
                        <ImageList variant="masonry" cols={cols} gap={10} sx={{ width: '100%' }}>
                            {images.map((image, index) => (
                                <ImageListItem key={image.src} onClick={() => handleOpen(index)}>
                                    <Fade in={true} timeout={500}>
                                        <img
                                            src={image.src}
                                            alt={image.title}
                                            loading="lazy"
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                objectFit: 'cover',
                                                cursor: 'pointer'
                                            }}
                                        />
                                    </Fade>
                                    <ImageListItemBar position="below" title={image.title}/>
                                </ImageListItem>
                            ))}
                        </ImageList>
                    </Box>
                    <Modal open={open} onClose={handleClose}>
                        <Box onClick={handleClose} sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexDirection: 'column',
                            width: '100%',
                            height: '100%',
                        }}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexDirection: 'row',
                                width: '100%',
                                height: 'auto',
                                padding: '0 5%',
                                gap: 1,
                            }}>
                                <Box
                                    height={{ xs: 48, md: 55 }}
                                    width={{ xs: 36, md: 30 }}
                                    my={4}
                                    display="flex"
                                    alignItems="center"
                                    sx={{
                                        cursor: 'pointer',
                                        border: '2px solid grey',
                                        bgcolor: '#393E46',
                                        '&:hover': {
                                            bgcolor: 'rgba(57,62,70,0.67)',
                                        },
                                    }}
                                    onClick={(e) => handlePrev(e)}
                                >
                                    <ArrowBackIosRoundedIcon onClick={(e) => handlePrev(e)} style={{cursor: 'pointer', color: 'white'}}/>
                                </Box>
                                <img
                                    src={images[selectedImageIndex]?.src}
                                    alt="Selected"
                                    className={classes.modalImage}
                                    style={{width: 'auto', height: 'auto'}}
                                    onClick={(e) => e.stopPropagation()}
                                />
                                <Box
                                    height={{ xs: 48, md: 55 }}
                                    width={{ xs: 36, md: 30 }}
                                    my={4}
                                    display="flex"
                                    alignItems="center"
                                    sx={{
                                        cursor: 'pointer',
                                        border: '2px solid grey',
                                        bgcolor: '#393E46',
                                        '&:hover': {
                                            bgcolor: 'rgba(57,62,70,0.67)',
                                        },
                                    }}
                                    onClick={(e) => handleNext(e)}
                                >
                                <ArrowForwardIosRoundedIcon onClick={(e) => handleNext(e)} style={{cursor: 'pointer', color: 'white'}}/>
                                </Box>
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexWrap: 'nowrap',
                                gap: '10px',
                                whiteSpace: 'nowrap',
                                overflowX: 'auto',
                                overflowY: 'hidden',
                                width: '100%',
                                pb: 2,
                            }}>
                                    {images.map((image, index) => (
                                        <img
                                            key={image.src}
                                            src={image.src}
                                            alt={image.title}
                                            style={{
                                                width: 64,
                                                height: 64,
                                                objectFit: 'cover',
                                                cursor: 'pointer',
                                                border: selectedImageIndex === index ? '2px solid #00ADB5' : 'none',
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectedImageIndex(index);
                                                setOpen(true);
                                            }}
                                        />
                                    ))}
                                </Box>
                        </Box>
                    </Modal>
                </Container>
            </div>
        </div>
    );
}